import type { AdminSession } from './types.js';

const KEY = 'veluga.admin.session';
let reauthenticationRequired = false;
export function needsStoredSessionReauthentication(): boolean { return reauthenticationRequired; }

export function getSession(): AdminSession | undefined {
  if (typeof sessionStorage === 'undefined') return undefined;
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return undefined;
  try {
    const session = JSON.parse(raw) as AdminSession;
    if (session?.sessionProtocol !== 'rotating_v1' || !session.refreshToken || !session.accessToken || !session.bootstrap?.membership?.roles ||
        !session.refreshExpiresAt || !Number.isFinite(Date.parse(session.refreshExpiresAt)) || Date.parse(session.refreshExpiresAt) <= Date.now()) {
      reauthenticationRequired = true;
      sessionStorage.removeItem(KEY);
      return undefined;
    }
    return session;
  } catch {
    sessionStorage.removeItem(KEY);
    return undefined;
  }
}

export function setSession(session: AdminSession | undefined): void {
  if (typeof sessionStorage === 'undefined') return;
  if (!session) sessionStorage.removeItem(KEY);
  else { sessionStorage.setItem(KEY, JSON.stringify(session)); reauthenticationRequired = false; }
}

export function getSessionRoles(session: AdminSession | undefined) {
  return session?.bootstrap.membership.roles ?? [];
}
